"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dom = _interopRequireDefault(require("./dom"));

var _crcDetailsRenderer = _interopRequireDefault(require("./crc-details-renderer"));

var _util = _interopRequireDefault(require("./util"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license
 * Copyright 2017 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
'use strict';
/* globals self CriticalRequestChainRenderer SnippetRenderer Util URL */

/** @typedef {import('./dom.js')} DOM */


var URL_PREFIXES = ['http://', 'https://', 'data:'];

var DetailsRenderer =
/*#__PURE__*/
function () {
  /**
   * @param {DOM} dom
   */
  function DetailsRenderer(dom) {
    _classCallCheck(this, DetailsRenderer);

    /** @type {DOM} */
    this._dom = dom;
    /** @type {ParentNode} */

    this._templateContext; // eslint-disable-line no-unused-expressions
  }
  /**
   * @param {ParentNode} context
   */


  _createClass(DetailsRenderer, [{
    key: "setTemplateContext",
    value: function setTemplateContext(context) {
      this._templateContext = context;
    }
    /**
     * @param {LH.Audit.Details} details
     * @return {Element|null}
     */

  }, {
    key: "render",
    value: function render(details) {
      switch (details.type) {
        case 'filmstrip':
          return this._renderFilmstrip(details);

        case 'list':
          return this._renderList(details);

        case 'table':
          return this._renderTable(details);

        case 'criticalrequestchain':
          return _crcDetailsRenderer["default"].render(this._dom, this._templateContext, details, this);

        case 'opportunity':
          return this._renderTable(details);
        // Internal-only details, not for rendering.

        case 'screenshot':
        case 'debugdata':
          return null;

        default:
          {
            // @ts-ignore tsc thinks this unreachable, but ts-ignore for error message just in case.
            var detailsType = details.type;
            throw new Error("Unknown type: ".concat(detailsType));
          }
      }
    }
    /**
     * @param {{value: number, granularity?: number}} details
     * @return {Element}
     */

  }, {
    key: "_renderBytes",
    value: function _renderBytes(details) {
      // TODO: handle displayUnit once we have something other than 'kb'
      var value = _util["default"].formatBytesToKB(details.value, details.granularity);

      return this._renderText(value);
    }
    /**
     * @param {{value: number, granularity?: number, displayUnit?: string}} details
     * @return {Element}
     */

  }, {
    key: "_renderMilliseconds",
    value: function _renderMilliseconds(details) {
      var value = _util["default"].formatMilliseconds(details.value, details.granularity);

      if (details.displayUnit === 'duration') {
        value = _util["default"].formatDuration(details.value);
      }

      return this._renderText(value);
    }
    /**
     * @param {string} text
     * @return {HTMLElement}
     */

  }, {
    key: "renderTextURL",
    value: function renderTextURL(text) {
      var url = text;
      var displayedPath;
      var displayedHost;
      var title;

      try {
        var parsed = _util["default"].parseURL(url);

        displayedPath = parsed.file === '/' ? parsed.origin : parsed.file;
        displayedHost = parsed.file === '/' ? '' : "(".concat(parsed.hostname, ")");
        title = url;
      } catch (e) {
        displayedPath = url;
      }

      var element = this._dom.createElement('div', 'lh-text__url');

      element.appendChild(this._renderLink({
        text: displayedPath,
        url: url
      }));

      if (displayedHost) {
        var hostElem = this._renderText(displayedHost);

        hostElem.classList.add('lh-text__url-host');
        element.appendChild(hostElem);
      }

      if (title) {
        element.title = url; // set the url on the element's dataset which we use to check 3rd party origins

        element.dataset.url = url;
      }

      return element;
    }
    /**
     * @param {{text: string, url: string}} details
     * @return {Element}
     */

  }, {
    key: "_renderLink",
    value: function _renderLink(details) {
      var allowedProtocols = ['https:', 'http:'];
      var url;

      try {
        url = new URL(details.url);
      } catch (_) {}

      if (!url || !allowedProtocols.includes(url.protocol)) {
        // Fall back to just the link text if invalid or protocol not allowed.
        return this._renderText(details.text);
      }

      var a = this._dom.createElement('a');

      a.rel = 'noopener';
      a.target = '_blank';
      a.textContent = details.text;
      a.href = url.href;
      return a;
    }
    /**
     * @param {string} text
     * @return {Element}
     */

  }, {
    key: "_renderText",
    value: function _renderText(text) {
      var element = this._dom.createElement('div', 'lh-text');

      element.textContent = text;
      return element;
    }
    /**
     * @param {string} text
     * @return {Element}
     */

  }, {
    key: "_renderNumeric",
    value: function _renderNumeric(text) {
      var element = this._dom.createElement('div', 'lh-numeric');

      element.textContent = text;
      return element;
    }
    /**
     * Create small thumbnail with scaled down image asset.
     * @param {string} details
     * @return {Element}
     */

  }, {
    key: "_renderThumbnail",
    value: function _renderThumbnail(details) {
      var element = this._dom.createElement('img', 'lh-thumbnail');

      var strValue = details;
      element.src = strValue;
      element.title = strValue;
      element.alt = '';
      return element;
    }
    /**
     * Render a details item value for embedding in a table. Renders the value
     * based on the heading's valueType, unless the value itself has a `type`
     * property to override it.
     * @param {LH.Audit.Details.TableItem[string] | LH.Audit.Details.OpportunityItem[string]} value
     * @param {LH.Audit.Details.OpportunityColumnHeading} heading
     * @return {Element|null}
     */

  }, {
    key: "_renderTableValue",
    value: function _renderTableValue(value, heading) {
      if (typeof value === 'undefined' || value === null) {
        return null;
      } // First deal with the possible object forms of value.


      if (_typeof(value) === 'object') {
        // The value's type overrides the heading's for this column.
        switch (value.type) {
          case 'code':
            {
              return this._renderCode(value.value);
            }

          case 'link':
            {
              return this._renderLink(value);
            }

          case 'node':
            {
              return this.renderNode(value);
            }

          case 'url':
            {
              return this.renderTextURL(value.value);
            }

          default:
            {
              throw new Error("Unknown valueType: ".concat(value.type));
            }
        }
      } // Next, deal with primitives.


      switch (heading.valueType) {
        case 'bytes':
          {
            var numValue = Number(value);
            return this._renderBytes({
              value: numValue,
              granularity: 1
            });
          }

        case 'code':
          {
            var strValue = String(value);
            return this._renderCode(strValue);
          }

        case 'ms':
          {
            var msValue = {
              value: Number(value),
              granularity: heading.granularity,
              displayUnit: heading.displayUnit
            };
            return this._renderMilliseconds(msValue);
          }

        case 'numeric':
          {
            var _strValue = String(value);

            return this._renderNumeric(_strValue);
          }

        case 'text':
          {
            var _strValue2 = String(value);

            return this._renderText(_strValue2);
          }

        case 'thumbnail':
          {
            var _strValue3 = String(value);

            return this._renderThumbnail(_strValue3);
          }

        case 'timespanMs':
          {
            var _numValue = Number(value);

            return this._renderMilliseconds({
              value: _numValue
            });
          }

        case 'url':
          {
            var _strValue4 = String(value);

            if (URL_PREFIXES.some(function (prefix) {
              return _strValue4.startsWith(prefix);
            })) {
              return this.renderTextURL(_strValue4);
            } else {
              // Fall back to <pre> rendering if not actually a URL.
              return this._renderCode(_strValue4);
            }
          }

        default:
          {
            throw new Error("Unknown valueType: ".concat(heading.valueType));
          }
      }
    }
    /**
     * Get the headings of a table-like details object, converted into the
     * OpportunityColumnHeading type until we have all details use the same
     * heading format.
     * @param {LH.Audit.Details.Table|LH.Audit.Details.Opportunity} tableLike
     * @return {Array<LH.Audit.Details.OpportunityColumnHeading>} header
     */

  }, {
    key: "_getCanonicalizedTableHeadings",
    value: function _getCanonicalizedTableHeadings(tableLike) {
      if (tableLike.type === 'opportunity') {
        return tableLike.headings;
      }

      return tableLike.headings.map(function (heading) {
        return {
          key: heading.key,
          label: heading.text,
          valueType: heading.itemType,
          displayUnit: heading.displayUnit,
          granularity: heading.granularity
        };
      });
    }
    /**
     * @param {LH.Audit.Details.Table|LH.Audit.Details.Opportunity} details
     * @return {Element}
     */

  }, {
    key: "_renderTable",
    value: function _renderTable(details) {
      if (!details.items.length) return this._dom.createElement('span');

      var tableElem = this._dom.createElement('table', 'lh-table');

      var theadElem = this._dom.createChildOf(tableElem, 'thead');

      var theadTrElem = this._dom.createChildOf(theadElem, 'tr');

      var headings = this._getCanonicalizedTableHeadings(details);

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = headings[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var heading = _step.value;
          var valueType = heading.valueType || 'text';
          var classes = "lh-table-column--".concat(valueType);

          var labelEl = this._dom.createElement('div', 'lh-text');

          labelEl.textContent = heading.label;

          this._dom.createChildOf(theadTrElem, 'th', classes).appendChild(labelEl);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var tbodyElem = this._dom.createChildOf(tableElem, 'tbody');

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = details.items[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var row = _step2.value;

          var rowElem = this._dom.createChildOf(tbodyElem, 'tr');

          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = headings[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var _heading = _step3.value;
              var value = row[_heading.key];

              var valueElement = this._renderTableValue(value, _heading);

              if (valueElement) {
                var _classes = "lh-table-column--".concat(_heading.valueType);

                this._dom.createChildOf(rowElem, 'td', _classes).appendChild(valueElement);
              } else {
                this._dom.createChildOf(rowElem, 'td', 'lh-table-column--empty');
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                _iterator3["return"]();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
            _iterator2["return"]();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return tableElem;
    }
    /**
     * @param {LH.Audit.Details.List} details
     * @return {Element}
     */

  }, {
    key: "_renderList",
    value: function _renderList(details) {
      var _this = this;

      var listContainer = this._dom.createElement('div', 'lh-list');

      details.items.forEach(function (item) {
        var snippetEl = SnippetRenderer.render(_this._dom, _this._templateContext, item, _this);
        listContainer.appendChild(snippetEl);
      });
      return listContainer;
    }
    /**
     * @param {LH.Audit.Details.NodeValue} item
     * @return {Element}
     * @protected
     */

  }, {
    key: "renderNode",
    value: function renderNode(item) {
      var element = this._dom.createElement('span', 'lh-node');

      if (item.nodeLabel) {
        var nodeLabelEl = this._dom.createElement('div');

        nodeLabelEl.textContent = item.nodeLabel;
        element.appendChild(nodeLabelEl);
      }

      if (item.snippet) {
        var snippetEl = this._dom.createElement('div');

        snippetEl.classList.add('lh-node__snippet');
        snippetEl.textContent = item.snippet;
        element.appendChild(snippetEl);
      }

      if (item.selector) {
        element.title = item.selector;
      }

      if (item.path) element.setAttribute('data-path', item.path);
      if (item.selector) element.setAttribute('data-selector', item.selector);
      if (item.snippet) element.setAttribute('data-snippet', item.snippet);
      return element;
    }
    /**
     * @param {LH.Audit.Details.Filmstrip} details
     * @return {Element}
     */

  }, {
    key: "_renderFilmstrip",
    value: function _renderFilmstrip(details) {
      var filmstripEl = this._dom.createElement('div', 'lh-filmstrip');

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = details.items[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var thumbnail = _step4.value;

          var frameEl = this._dom.createChildOf(filmstripEl, 'div', 'lh-filmstrip__frame');

          this._dom.createChildOf(frameEl, 'img', 'lh-filmstrip__thumbnail', {
            src: thumbnail.data,
            alt: "Screenshot"
          });
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) {
            _iterator4["return"]();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return filmstripEl;
    }
    /**
     * @param {string} text
     * @return {Element}
     */

  }, {
    key: "_renderCode",
    value: function _renderCode(text) {
      var pre = this._dom.createElement('pre', 'lh-code');

      pre.textContent = text;
      return pre;
    }
  }]);

  return DetailsRenderer;
}(); // if (typeof module !== 'undefined' && module.exports) {
//   module.exports = DetailsRenderer;
// } else {
//   self.DetailsRenderer = DetailsRenderer;
// }


var _default = DetailsRenderer;
exports["default"] = _default;